import fcl from "../config.js";

export async function addKeyToAccount(publicKey, signatureAlgorithm, hashAlgorithm, weight) {
  if(!publicKey || !signatureAlgorithm || !hashAlgorithm || !weight){
    console.log("Missing parameters")
    console.log( signatureAlgorithm, hashAlgorithm, weight)
    alert("Missing parameters")
  }
    try {
        const transactionId = await fcl.mutate({
            cadence: `
            transaction(publicKey: String, signatureAlgorithm: String, hashAlgorithm: String, weight: UFix64) {
                prepare(signer: AuthAccount) {
                    
                    let publicKeyBytes = publicKey.decodeHex()

                    let key = PublicKey(
                        publicKey: publicKeyBytes,
                        signatureAlgorithm: (signatureAlgorithm == "ECDSA_P256" ? SignatureAlgorithm.ECDSA_P256: SignatureAlgorithm.ECDSA_secp256k1)
                    )

                    var clampledWeight = weight

                    if(clampledWeight > 1000.0){
                      clampledWeight = 1000.0
                    }
            
                    signer.keys.add(
                        publicKey: key,
                        hashAlgorithm:(hashAlgorithm == "SHA3_256" ? HashAlgorithm.SHA3_256 : HashAlgorithm.SHA2_256),
                        weight: clampledWeight
                    )
                }
            }
            `,
            args: (arg, t) => [arg(publicKey, t.String), arg(signatureAlgorithm, t.String), arg(hashAlgorithm, t.String), arg(weight, t.UFix64)],
            proposer: fcl.currentUser,
            payer: fcl.currentUser,
            authorizations: [fcl.currentUser],
            limit: 50
          })
          
          const transaction = await fcl.tx(transactionId).onceSealed()
          console.log(transaction)
          alert("Transaction Successful")

    } catch (error) {
      console.log("err", error);
      alert("Failed, Try Again!")

    }
}


export async function revokeKeyFromAccount(keyIndex) {
    try {
        const transactionId = await fcl.mutate({
            cadence: `
            transaction(keyIndex: Int){
                prepare(signer: AuthAccount){
                  signer.keys.revoke(keyIndex:keyIndex)
                }
              }
            `,
            args: (arg, t) => [arg(keyIndex, t.Int)],
            proposer: fcl.currentUser,
            payer: fcl.currentUser,
            authorizations: [fcl.currentUser],
            limit: 50
          })
          
          const transaction = await fcl.tx(transactionId).onceSealed()
          console.log(transaction)
          alert("Transaction Successful")
    } catch (error) {
      console.log("err", error);
      alert("Failed, Try Again!")

    }
}



export async function sendCapability(capabilityPath, capabilityName, recipient) {
  try {
      const transactionId = await fcl.mutate({
          cadence: `
          transaction(capabilityPath: PublicPath, capabilityName: String, recipient: Address){
              prepare(signer: AuthAccount){
                let publicAccount = getAccount(signer.address)

                let capability = signer.getCapability(capabilityPath)
                signer.inbox.publish(capability, name: capabilityName, recipient: recipient)
                
              }
            }
          `,
          args: (arg, t) => [arg(capabilityPath, t.Path), arg(capabilityName, t.String), arg(recipient, t.Address)],
          proposer: fcl.currentUser,
          payer: fcl.currentUser,
          authorizations: [fcl.currentUser],
          limit: 50
        })
        
        const transaction = await fcl.tx(transactionId).onceSealed()
        console.log(transaction)
        alert("Transaction Successful")
  } catch (error) {
    console.log("err", error);
    alert("Failed, Try Again!")
  }
}


export async function unsendCapability(capabilityPath, capabilityName) {
  try {
      const transactionId = await fcl.mutate({
          cadence: `
          transaction(capabilityPath: PublicPath, capabilityName: String){
              prepare(signer: AuthAccount){
                let publicAccount = getAccount(signer.address)

                let capability = signer.getCapability(capabilityPath)
                signer.inbox.unpublish(capability, name: capabilityName, recipient: recipient)
                
              }
            }
          `,
          args: (arg, t) => [arg(capabilityPath, t.Path), arg(capabilityName, t.String)],
          proposer: fcl.currentUser,
          payer: fcl.currentUser,
          authorizations: [fcl.currentUser],
          limit: 50
        })
        
        const transaction = await fcl.tx(transactionId).onceSealed()
        console.log(transaction)
        alert("Transaction Successful")
  } catch (error) {
    console.log("err", error);
    alert("Failed, Try Again!")
  }
}


// export async function claimCapability(capabilityType, capabilityName, sender) {
//   try {
//       const transactionId = await fcl.mutate({
//           cadence: `
//           transaction(capabilityPath: PublicPath, capabilityName: String, recipient: Address){
//               prepare(signer: AuthAccount){
//                 let publicAccount = getAccount(signer.address)

//                 let capability = signer.getCapability(capabilityPath)
//                 signer.inbox.publish(capability, name: capabilityName, recipient: recipient)
                
//               }
//             }
//           `,
//           args: (arg, t) => [arg(capabilityPath, t.Path), arg(capabilityName, t.String), arg(recipient, t.Address)],
//           proposer: fcl.currentUser,
//           payer: fcl.currentUser,
//           authorizations: [fcl.currentUser],
//           limit: 50
//         })
        
//         const transaction = await fcl.tx(transactionId).onceSealed()
//         console.log(transaction)
//   } catch (error) {
//     console.log("err", error);
//   }
// }